import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import "react-datepicker/dist/react-datepicker.css";
import { useEntidadeContext } from '../../EntidadeContext';
import { useAlertModal } from '../../AlertModalContext';
import axios from 'axios';

registerLocale('pt-BR', ptBR);

/* ── constantes ── */
const initialHorariosState = {
  dom: { ativo: false, manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
  seg: { ativo: true,  manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
  ter: { ativo: true,  manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
  qua: { ativo: true,  manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
  qui: { ativo: true,  manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
  sex: { ativo: true,  manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
  sab: { ativo: true,  manha_inicio: '08:00', manha_fim: '12:00', tarde_inicio: '13:00', tarde_fim: '18:00', noite_inicio: '18:30', noite_fim: '20:00' },
};
const diasDaSemana = { seg: 'Segunda', ter: 'Terça', qua: 'Quarta', qui: 'Quinta', sex: 'Sexta', sab: 'Sábado', dom: 'Domingo' };

const TURNOS = [
  { campo_inicio: 'manha_inicio', campo_fim: 'manha_fim',   label: 'Manhã',  color: '#f59e0b', bg: '#fffbeb' },
  { campo_inicio: 'tarde_inicio', campo_fim: 'tarde_fim',   label: 'Tarde',  color: '#2563eb', bg: '#eff6ff' },
  { campo_inicio: 'noite_inicio', campo_fim: 'noite_fim',   label: 'Noite',  color: '#7c3aed', bg: '#f5f3ff' },
];

/* ── helpers visuais ── */
const inputBase = {
  width: '100%', padding: '7px 10px', borderRadius: '7px',
  border: '1px solid #e5e7eb', fontSize: '12px', color: '#374151',
  fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff',
  boxSizing: 'border-box', transition: 'border-color .15s',
};
const inputDisabled = { ...inputBase, backgroundColor: '#f9fafb', color: '#d1d5db', cursor: 'not-allowed' };
const fh = {
  onFocus: e => { e.target.style.borderColor = '#2563eb'; },
  onBlur:  e => { e.target.style.borderColor = '#e5e7eb'; },
};

const ICONS = {
  clock:    'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
  calendar: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  ban:      'M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636',
  save:     'M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4',
  plus:     'M12 4v16m8-8H4',
  trash:    'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16',
};

const SvgIcon = ({ d, size = 14, color = 'currentColor', stroke = 2 }) => (
  <svg width={size} height={size} fill="none" stroke={color} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={stroke} d={d} />
  </svg>
);

const Btn = ({ children, onClick, disabled, loading, variant = 'primary', small }) => {
  const variants = {
    primary:   { bg: 'linear-gradient(135deg,#1e3a5f,#2563eb)', color: '#fff', border: 'none' },
    success:   { bg: 'linear-gradient(135deg,#14532d,#16a34a)', color: '#fff', border: 'none' },
    danger:    { bg: '#fff', color: '#dc2626', border: '1px solid #fecaca' },
    secondary: { bg: '#fff', color: '#374151', border: '1px solid #e5e7eb' },
  };
  const v = variants[variant] || variants.primary;
  return (
    <button
      type="button" onClick={onClick} disabled={disabled || loading}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '5px',
        padding: small ? '5px 10px' : '9px 18px', borderRadius: '8px',
        border: v.border, background: (disabled || loading) ? '#f3f4f6' : v.bg,
        color: (disabled || loading) ? '#9ca3af' : v.color,
        fontSize: small ? '11px' : '13px', fontWeight: '600', fontFamily: 'inherit',
        cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
      }}
    >
      {loading && <Spinner as="span" animation="border" size="sm" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />}
      {children}
    </button>
  );
};

const AgendasConfigTab = () => {
  const { currentEntidade, setCurrentEntidade } = useEntidadeContext();
  const { showAlertModal } = useAlertModal();

  const [isLoading, setIsLoading]   = useState(true);
  const [isSaving, setIsSaving]     = useState(false);
  const [duracaoPadrao, setDuracaoPadrao] = useState(30);
  const [horarios, setHorarios]     = useState(initialHorariosState);
  const [feriados, setFeriados]     = useState([]);
  const [newFeriadoDate, setNewFeriadoDate] = useState(new Date());
  const [newFeriadoDesc, setNewFeriadoDesc] = useState('');
  const [diasBloqueados, setDiasBloqueados] = useState([]);
  const [newBloqueioDate, setNewBloqueioDate] = useState(new Date());
  const [newBloqueioDesc, setNewBloqueioDesc] = useState('');

  useEffect(() => {
    const fetchAgendaConfig = async () => {
      if (!currentEntidade) return;
      setIsLoading(true);
      try {
        const response = await axios.get(`/api/entidades/${currentEntidade.id}/agenda-config`);
        const fetchedHorarios = response.data.horarios || {};
        const completeHorarios = {};
        for (const diaKey in diasDaSemana) {
          completeHorarios[diaKey] = { ...initialHorariosState[diaKey], ...(fetchedHorarios[diaKey] || {}) };
        }
        setHorarios(completeHorarios);
        setDuracaoPadrao(response.data.duracao_padrao || 30);
        setFeriados(response.data.feriados || []);
        setDiasBloqueados(response.data.diasBloqueados || []);
      } catch {
        showAlertModal('Erro', 'Não foi possível carregar as configurações da agenda.', 'danger');
        setHorarios(initialHorariosState); setDuracaoPadrao(30);
        setFeriados([]); setDiasBloqueados([]);
      } finally { setIsLoading(false); }
    };
    fetchAgendaConfig();
  }, [currentEntidade, showAlertModal]);

  const handleHorarioChange = (dia, campo, valor) => {
    setHorarios(prev => ({ ...prev, [dia]: { ...prev[dia], [campo]: valor } }));
  };

  const handleSaveHorarios = async () => {
    if (!currentEntidade) { showAlertModal('Erro', 'Nenhuma entidade selecionada.', 'danger'); return; }
    setIsSaving(true);
    const formattedHorarios = {};
    for (const diaKey in horarios) {
      const dia = horarios[diaKey];
      formattedHorarios[diaKey] = {
        ...dia,
        manha_inicio: dia.manha_inicio?.substring(0, 5) || null,
        manha_fim:    dia.manha_fim?.substring(0, 5)    || null,
        tarde_inicio: dia.tarde_inicio?.substring(0, 5) || null,
        tarde_fim:    dia.tarde_fim?.substring(0, 5)    || null,
        noite_inicio: dia.noite_inicio?.substring(0, 5) || null,
        noite_fim:    dia.noite_fim?.substring(0, 5)    || null,
      };
    }
    try {
      const response = await axios.post(`/api/entidades/${currentEntidade.id}/agenda-config`, { horarios: formattedHorarios, duracao_padrao: duracaoPadrao });
      showAlertModal('Sucesso', 'Horários salvos com sucesso!', 'success');
      setCurrentEntidade(response.data.entidade);
    } catch (err) {
      showAlertModal('Erro', err.response?.data?.message || 'Erro ao salvar horários.', 'danger');
    } finally { setIsSaving(false); }
  };

  const handleAddFeriado = async () => {
    if (!newFeriadoDesc.trim()) { showAlertModal('Atenção', 'A descrição do feriado é obrigatória.', 'warning'); return; }
    setIsSaving(true);
    try {
      const response = await axios.post(`/api/entidades/${currentEntidade.id}/agenda-excecoes`, { data: newFeriadoDate.toISOString().split('T')[0], descricao: newFeriadoDesc, tipo: 'feriado' });
      setFeriados(prev => [...prev, response.data.feriado].sort((a, b) => new Date(a.data) - new Date(b.data)));
      setNewFeriadoDesc('');
      showAlertModal('Sucesso', 'Feriado adicionado!', 'success');
    } catch (err) { showAlertModal('Erro', err.response?.data?.message || 'Erro ao adicionar feriado.', 'danger'); }
    finally { setIsSaving(false); }
  };

  const handleRemoveFeriado = async (id) => {
    if (!window.confirm('Remover este feriado?')) return;
    setIsSaving(true);
    try {
      await axios.delete(`/api/agenda-excecoes/${id}`);
      setFeriados(prev => prev.filter(f => f.id !== id));
      showAlertModal('Sucesso', 'Feriado removido!', 'success');
    } catch (err) { showAlertModal('Erro', err.response?.data?.message || 'Erro ao remover.', 'danger'); }
    finally { setIsSaving(false); }
  };

  const handleAddBloqueio = async () => {
    if (!newBloqueioDesc.trim()) { showAlertModal('Atenção', 'O motivo do bloqueio é obrigatório.', 'warning'); return; }
    setIsSaving(true);
    try {
      const response = await axios.post(`/api/entidades/${currentEntidade.id}/agenda-excecoes`, { data: newBloqueioDate.toISOString().split('T')[0], descricao: newBloqueioDesc, tipo: 'bloqueio' });
      setDiasBloqueados(prev => [...prev, response.data.dia_bloqueado].sort((a, b) => new Date(a.data) - new Date(b.data)));
      setNewBloqueioDesc('');
      showAlertModal('Sucesso', 'Dia bloqueado adicionado!', 'success');
    } catch (err) { showAlertModal('Erro', err.response?.data?.message || 'Erro ao adicionar bloqueio.', 'danger'); }
    finally { setIsSaving(false); }
  };

  const handleRemoveBloqueio = async (id) => {
    if (!window.confirm('Remover este dia bloqueado?')) return;
    setIsSaving(true);
    try {
      await axios.delete(`/api/agenda-excecoes/${id}`);
      setDiasBloqueados(prev => prev.filter(b => b.id !== id));
      showAlertModal('Sucesso', 'Dia bloqueado removido!', 'success');
    } catch (err) { showAlertModal('Erro', err.response?.data?.message || 'Erro ao remover.', 'danger'); }
    finally { setIsSaving(false); }
  };

  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        .dp-custom .react-datepicker__input-container input {
          width: 100%; padding: 7px 10px; border-radius: 7px; border: 1px solid #e5e7eb;
          font-size: 12px; font-family: inherit; outline: none; background: #fff; box-sizing: border-box;
        }
      `}</style>

      {/* ── HEADER ── */}
      <div style={{ background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', borderRadius: '14px', padding: '20px 24px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '14px' }}>
        <div style={{ width: '44px', height: '44px', borderRadius: '12px', backgroundColor: 'rgba(255,255,255,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <SvgIcon d={ICONS.clock} size={22} color="#fff" stroke={1.8} />
        </div>
        <div>
          <div style={{ fontSize: '16px', fontWeight: '800', color: '#fff' }}>Configurações de Agenda</div>
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,.7)' }}>Horários de atendimento, feriados e dias bloqueados</div>
        </div>
      </div>

      {isLoading ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '48px 0', gap: '12px' }}>
          <Spinner animation="border" variant="primary" style={{ width: '28px', height: '28px' }} />
          <span style={{ fontSize: '13px', color: '#6b7280' }}>Carregando configurações...</span>
        </div>
      ) : (
        <>
          {/* ── BLOCO HORÁRIOS ── */}
          <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '16px' }}>

            {/* Cabeçalho da seção + duração */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', paddingBottom: '14px', borderBottom: '2px solid #f1f5f9' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '28px', height: '28px', borderRadius: '7px', background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <SvgIcon d={ICONS.clock} size={14} color="#fff" />
                </div>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#1e3a5f' }}>Horários de Atendimento Padrão</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.5px', whiteSpace: 'nowrap' }}>
                  Duração (min)
                </label>
                <input
                  type="number" value={duracaoPadrao}
                  onChange={e => { if (e.target.value.length <= 2) setDuracaoPadrao(e.target.value); }}
                  onBlur={e => {
                    const v = parseInt(e.target.value, 10);
                    setDuracaoPadrao(isNaN(v) || v < 15 ? 15 : v > 60 ? 60 : v);
                  }}
                  style={{ ...inputBase, width: '70px', textAlign: 'center', padding: '7px 8px' }}
                  {...fh}
                />
              </div>
            </div>

            {/* Legenda dos turnos */}
            <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
              {TURNOS.map(t => (
                <div key={t.label} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '11px', fontWeight: '600', color: t.color }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: t.color }} />
                  {t.label} (início → fim)
                </div>
              ))}
            </div>

            {/* Grade de dias */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {Object.entries(diasDaSemana).map(([diaKey, diaNome]) => {
                const dia = horarios[diaKey];
                return (
                  <div
                    key={diaKey}
                    style={{
                      display: 'grid', gridTemplateColumns: '130px 1fr',
                      alignItems: 'center', gap: '12px',
                      padding: '10px 14px', borderRadius: '10px',
                      backgroundColor: dia.ativo ? '#fafafa' : '#f9fafb',
                      border: `1px solid ${dia.ativo ? '#e5e7eb' : '#f1f5f9'}`,
                      transition: 'background .15s',
                    }}
                  >
                    {/* Toggle + nome */}
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', userSelect: 'none' }}>
                      <div style={{ position: 'relative', width: '36px', height: '20px', flexShrink: 0 }}>
                        <input
                          type="checkbox" checked={dia.ativo}
                          onChange={e => handleHorarioChange(diaKey, 'ativo', e.target.checked)}
                          style={{ opacity: 0, width: 0, height: 0 }}
                        />
                        <span style={{ position: 'absolute', inset: 0, borderRadius: '999px', backgroundColor: dia.ativo ? '#2563eb' : '#d1d5db', transition: '.2s' }} />
                        <span style={{ position: 'absolute', left: dia.ativo ? '18px' : '2px', top: '2px', width: '16px', height: '16px', borderRadius: '50%', backgroundColor: '#fff', transition: '.2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }} />
                      </div>
                      <span style={{ fontSize: '12px', fontWeight: '700', color: dia.ativo ? '#111827' : '#9ca3af', minWidth: '60px' }}>{diaNome}</span>
                    </label>

                    {/* Campos de horário agrupados por turno */}
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {TURNOS.map(t => (
                        <div key={t.label} style={{ display: 'flex', alignItems: 'center', gap: '4px', backgroundColor: dia.ativo ? t.bg : '#f9fafb', borderRadius: '7px', padding: '4px 8px', border: `1px solid ${dia.ativo ? t.color + '33' : '#f1f5f9'}` }}>
                          <span style={{ fontSize: '10px', fontWeight: '700', color: dia.ativo ? t.color : '#d1d5db', minWidth: '36px' }}>{t.label}</span>
                          <input type="time" value={dia[t.campo_inicio]} onChange={e => handleHorarioChange(diaKey, t.campo_inicio, e.target.value)}
                            disabled={!dia.ativo} style={dia.ativo ? { ...inputBase, width: '90px', padding: '4px 6px', fontSize: '11px' } : { ...inputDisabled, width: '90px', padding: '4px 6px', fontSize: '11px' }} />
                          <span style={{ fontSize: '10px', color: '#9ca3af' }}>→</span>
                          <input type="time" value={dia[t.campo_fim]} onChange={e => handleHorarioChange(diaKey, t.campo_fim, e.target.value)}
                            disabled={!dia.ativo} style={dia.ativo ? { ...inputBase, width: '90px', padding: '4px 6px', fontSize: '11px' } : { ...inputDisabled, width: '90px', padding: '4px 6px', fontSize: '11px' }} />
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <Btn onClick={handleSaveHorarios} disabled={isSaving} loading={isSaving} variant="primary">
                <SvgIcon d={ICONS.save} size={13} color="#fff" />
                {isSaving ? 'Salvando...' : 'Salvar Horários'}
              </Btn>
            </div>
          </div>

          {/* ── FERIADOS + BLOQUEIOS ── */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

            {/* Feriados */}
            <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb', padding: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #f1f5f9' }}>
                <div style={{ width: '26px', height: '26px', borderRadius: '7px', background: 'linear-gradient(135deg,#78350f,#f59e0b)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <SvgIcon d={ICONS.calendar} size={13} color="#fff" />
                </div>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#1e3a5f' }}>Feriados</span>
                <span style={{ fontSize: '11px', fontWeight: '600', padding: '2px 7px', borderRadius: '999px', backgroundColor: '#fffbeb', color: '#d97706', border: '1px solid #fde68a' }}>
                  {feriados.length}
                </span>
              </div>

              {/* Lista */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px', maxHeight: '200px', overflowY: 'auto' }}>
                {feriados.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#9ca3af', fontSize: '12px' }}>Nenhum feriado cadastrado</div>
                ) : feriados.map(f => (
                  <div key={f.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderRadius: '8px', backgroundColor: '#fffbeb', border: '1px solid #fde68a' }}>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '700', color: '#92400e' }}>{new Date(f.data + 'T00:00:00').toLocaleDateString('pt-BR')}</div>
                      <div style={{ fontSize: '11px', color: '#b45309' }}>{f.descricao}</div>
                    </div>
                    <button type="button" onClick={() => handleRemoveFeriado(f.id)} disabled={isSaving}
                      style={{ width: '26px', height: '26px', borderRadius: '6px', border: '1px solid #fecaca', backgroundColor: '#fef2f2', color: '#dc2626', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <SvgIcon d={ICONS.trash} size={11} color="#dc2626" />
                    </button>
                  </div>
                ))}
              </div>

              {/* Adicionar */}
              <div style={{ backgroundColor: '#f8fafc', borderRadius: '10px', border: '1px solid #e5e7eb', padding: '14px' }}>
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '10px' }}>Adicionar Feriado</div>
                <div className="dp-custom" style={{ marginBottom: '8px' }}>
                  <DatePicker selected={newFeriadoDate} onChange={setNewFeriadoDate} dateFormat="dd/MM/yyyy" locale="pt-BR" />
                </div>
                <input type="text" value={newFeriadoDesc} onChange={e => setNewFeriadoDesc(e.target.value)}
                  style={{ ...inputBase, marginBottom: '8px' }} placeholder="Descrição (Ex: Natal)" {...fh} />
                <Btn onClick={handleAddFeriado} disabled={isSaving} variant="success" small>
                  <SvgIcon d={ICONS.plus} size={11} color="#fff" />
                  Adicionar
                </Btn>
              </div>
            </div>

            {/* Dias Bloqueados */}
            <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb', padding: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #f1f5f9' }}>
                <div style={{ width: '26px', height: '26px', borderRadius: '7px', background: 'linear-gradient(135deg,#7f1d1d,#dc2626)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <SvgIcon d={ICONS.ban} size={13} color="#fff" />
                </div>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#1e3a5f' }}>Dias Bloqueados</span>
                <span style={{ fontSize: '11px', fontWeight: '600', padding: '2px 7px', borderRadius: '999px', backgroundColor: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' }}>
                  {diasBloqueados.length}
                </span>
              </div>

              {/* Lista */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px', maxHeight: '200px', overflowY: 'auto' }}>
                {diasBloqueados.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#9ca3af', fontSize: '12px' }}>Nenhum dia bloqueado</div>
                ) : diasBloqueados.map(b => (
                  <div key={b.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderRadius: '8px', backgroundColor: '#fef2f2', border: '1px solid #fecaca' }}>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '700', color: '#991b1b' }}>{new Date(b.data + 'T00:00:00').toLocaleDateString('pt-BR')}</div>
                      <div style={{ fontSize: '11px', color: '#b91c1c' }}>{b.descricao}</div>
                    </div>
                    <button type="button" onClick={() => handleRemoveBloqueio(b.id)} disabled={isSaving}
                      style={{ width: '26px', height: '26px', borderRadius: '6px', border: '1px solid #fecaca', backgroundColor: '#fef2f2', color: '#dc2626', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <SvgIcon d={ICONS.trash} size={11} color="#dc2626" />
                    </button>
                  </div>
                ))}
              </div>

              {/* Adicionar */}
              <div style={{ backgroundColor: '#f8fafc', borderRadius: '10px', border: '1px solid #e5e7eb', padding: '14px' }}>
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '10px' }}>Adicionar Bloqueio</div>
                <div className="dp-custom" style={{ marginBottom: '8px' }}>
                  <DatePicker selected={newBloqueioDate} onChange={setNewBloqueioDate} dateFormat="dd/MM/yyyy" locale="pt-BR" />
                </div>
                <input type="text" value={newBloqueioDesc} onChange={e => setNewBloqueioDesc(e.target.value)}
                  style={{ ...inputBase, marginBottom: '8px' }} placeholder="Motivo (Ex: Recesso)" {...fh} />
                <Btn onClick={handleAddBloqueio} disabled={isSaving} variant="danger" small>
                  <SvgIcon d={ICONS.plus} size={11} color="#dc2626" />
                  Adicionar
                </Btn>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AgendasConfigTab;
